module.exports = __webpack_public_path__ + "static/img/Robert-Derby.7156873.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Robert-Derby.jpg
// module id = gc5L
// module chunks = 0